import { graphql, useStaticQuery } from 'gatsby';

const useFeatureFlagQuery = () => {
    const { application } = useStaticQuery(graphql`
        {
            application {
                data {
                    config {
                        featureFlagConfig {
                            fgtm
                            fformloader
                            foptimizely
                            fpagespeedplus
                        }
                    }
                }
            }
        }
    `);

    const { config } = application.data;

    return config.featureFlagConfig || {};
};

export default useFeatureFlagQuery;
